<div class="manual-pay-container">
  <ng-content />
  <div class="payment-information">
    <p id="paymentReceiver">Empfänger: {{ manualPaymentConfiguration.paymentReceiver }}</p>
    <p id="iban">IBAN: {{ formatIban(manualPaymentConfiguration.iban) }}</p>
    <p id="bic">BIC: {{ manualPaymentConfiguration.bic }}</p>
    <p id="bank">Bank: {{ manualPaymentConfiguration.bank }}</p>
    <p id="reasonForPayment">Verwendungszweck: {{ reasonForPayment }}</p>
  </div>
</div>
<ng-content select=".disclaimer" />
